//DONE
import {
  ARMOR_SLOTS,
  ADVANTAGE,
  DISADVANTAGE,
  CONDITION,
  HOPE,
  STRESS,
} from '../../character/content/templates';

export default function AdditionalRules() {
  return (
    <>
      <p>The following rules apply to many aspects of the game.</p>

      <h3 id="rounding-up">ROUNDING UP</h3>
      <p>This game doesn't use fractions; if you need to round to a whole number, round up unless otherwise specified. When in doubt, resolve any ambiguity in favor of the PCs.</p>

      <h3 id="rerolling-dice">REROLLING DICE</h3>
      <p>When a feature allows you to reroll a die, you always take the new result unless the feature specifically says otherwise.</p>

      <h3 id="incoming-damage">INCOMING DAMAGE</h3>
      <p>Incoming damage means the total damage from a single attack or source, before {ARMOR_SLOTS} are marked.</p>

      <h3 id="simultaneous-effects">SIMULTANEOUS EFFECTS</h3>
      <p>If the resolution order of multiple effects is unclear, the person in control of the effects (player or GM) decides what order to resolve them in.</p>

      <h3 id="stacking-effects">STACKING EFFECTS</h3>
      <p>Unless stated otherwise, all effects beside {CONDITION}s and {ADVANTAGE}/{DISADVANTAGE} can stack.</p>

      <h3 id="ongoing-spell-effects">ONGOING SPELL EFFECTS</h3>
      <p>If an effect doesn't have a listed mechanical expiration, it only ends when decided by the controlling player, the GM, or the demands of the fiction.</p>

      <h3 id="spending-resources">SPENDING RESOURCES</h3>
      <p>Unless an effect states otherwise, you can't spend {HOPE} or mark {STRESS} multiple times on the same feature to increase or repeat its effects on the same roll.</p>

      <h3 id="using-features-after-roll">USING FEATURES AFTER A ROLL</h3>
      <p>If a feature allows you to affect a roll after the result has been totaled, you can use it after the GM declares whether the roll succeeds or fails, but not after the consequences unfold or another roll is made.</p>
    </>
  );
}
